<!--header image-->
<div class="jumbotron py-4 m-start"  [ngClass]="{'animated':isAnimated}" >
  <div class="px-0 container d-flex flex-column align-items-center" [ngClass]="{'animated':isAnimated}">
    <img src="assets/images/new-logo.png" class="m-logo mt-4 mb-5" alt="{{'COMMON.LOGO_ALT' | translate}}" />
    <h1 class="">{{'START.TITLE1' | translate}}</h1>
    <p class="m-sec-title">{{'START.EXPLANATION' | translate}}</p>
    <div class="row m-pt-5">
    <div class="col pr-4">
      <button (click)="naviate('outer')"
        class="mt-3 btn btn-lg btn-primary m-start-btn opacity-an transition-delay-3-5" 
        [ngClass]="{'animated':isAnimated}">
        <div>{{'START.COSTUMER_OUT_BTN' | translate}}</div>
      </button>
    </div>
      <div class="col pr-4">
        <button (click)="naviate('inner')" 
          class="mt-3 btn btn-lg btn-primary m-start-btn opacity-an transition-delay-3-5" 
          [ngClass]="{'animated':isAnimated}">
          <div>{{'START.COSTUMER_IN_BTN' | translate}}</div>
        </button>
      </div>
      <div class="col pr-4">
        <button (click)="naviate('advisor')"
          class="mt-3 btn btn-lg btn-primary m-start-btn opacity-an transition-delay-3-5" 
          [ngClass]="{'animated':isAnimated}">
          <div>{{'START.COUNSELOR_BTN' | translate}}</div>
        </button>
      </div>
    </div>
     <!-- <inner-tooltip [qTitle]="'START.LINK_TOOLTIP'|translate"
                    [text]="'START.TOOLTIP_TEXT'|translate" 
                    class="m-start-tooltip">
      </inner-tooltip> 	 -->
      <div class="m-link1"></div>
      <div (click)="openSite(1)" class="m-cursor">{{'START.LINK1' | translate}}</div>
      <div class="m-link2"></div>
      <div (click)="openSite(2)" class="m-cursor">{{'START.LINK2' | translate}}</div>
  </div>
</div>
<!--lead icons-->
<!-- <div class="container my-5">
  <div class="d-flex flex-column flex-md-row">
    <div class="d-flex col-md-4 col-12 pr-md-5 pb-3 align-items-center opacity-an transition-delay-4" 
        [ngClass]="{'animated':isAnimated}">
      <img class="mx-2 lead-img" src="assets/images/check-list.png" alt="{{'START.LEAD1_ALT' | translate}}">
      <div class="w-75">
        <h5>{{'START.LEAD1' | translate}}</h5>
      </div>
    </div>
    <div class="d-flex col-md-4 col-12 pr-md-5 pb-3 align-items-center opacity-an transition-delay-5" 
         [ngClass]="{'animated':isAnimated}">
      <img class="mx-2 lead-img" src="assets/images/clock.png" alt="{{'START.LEAD2_ALT' | translate}}">
      <div class="w-75 w-md-50">
        <h5>{{'START.LEAD2' | translate}}</h5>
      </div>
    </div>
    <div class="d-flex col-md-4 col-12 pb-3 align-items-center opacity-an transition-delay-5-5" 
         [ngClass]="{'animated':isAnimated}">
      <img class="mx-2 lead-img" src="assets/images/home.png" alt="{{'START.LEAD3_ALT' | translate}}">
      <div class="w-75">
        <h5>{{'START.LEAD3' | translate}}</h5>
      </div>
    </div>
  </div>
</div> -->
<!--right text-->
<div class="container d-flex flex-column flex-md-row opacity-an transition-delay-5" 
    [ngClass]="{'animated':isAnimated}">
  <div class="w-100 w-md-50 text-md-center">
    <h3 class="h1 my-5 font-weight-bold">{{'START.NEEDS' | translate}}</h3>
    <div class="px-4 w-md-75 w-100 mx-auto">
      <h4 class="mt-5 font-weight-bold">{{'START.NEEDS1' | translate}}</h4>
      <p>{{'START.NEEDS2' | translate}}</p>
      <h4 class="mt-3 font-weight-bold">{{'START.NEEDS3' | translate}}</h4>
      <p>{{'START.NEEDS4' | translate}}</p>
    </div>
  </div>

  <span class="m-vertial-line mt-5"></span>
<!--left text-->
  <div class="w-100 w-md-50 text-md-center">
    <h3 class="h1 my-5 font-weight-bold">{{'START.RECEIVES' | translate}}</h3>
    <div class="px-4 w-md-75 w-100 mx-auto mt-5">
      <div>{{'START.RECEIVES1' | translate}}</div>
      <div>{{'START.RECEIVES2' | translate}}</div>
      <div>{{'START.RECEIVES3' | translate}}</div>
      <div>{{'START.RECEIVES4' | translate}}</div>
    </div>
  </div>
</div>
<!--buttons-->
<!-- <div class="container d-flex justify-content-center opacity-an transition-delay-7 mb-3" [ngClass]="{'animated':isAnimated}">
  <div class="row mt-5">
    <div class="col px-5">
      <button (click)="naviate('outer')" 
        class="mt-3 btn btn-lg btn-primary m-start-btn-2">
        <div>{{'START.COSTUMER_OUT_BTN1' | translate}}</div>
        <div>{{'START.COSTUMER_OUT_BTN2' | translate}}</div>
      </button>
    </div>
    <div class="col px-5">
      <button (click)="naviate('inner')" 
        class="mt-3 btn btn-lg btn-primary m-start-btn-2">
        <div>{{'START.COSTUMER_IN_BTN1' | translate}}</div>
        <div>{{'START.COSTUMER_IN_BTN2' | translate}}</div>
      </button>
    </div>
    <div class="col px-5">
      <button (click)="naviate('advisor')"
        class="mt-3 btn btn-lg btn-primary m-start-btn-2">
        <div>{{'START.COUNSELOR_BTN1' | translate}}</div>
        <div>{{'START.COUNSELOR_BTN2' | translate}}</div>
      </button>
    </div>
  </div>
</div>
<div class="pt-5 pr-5 h5 font-weight-bold text-md-center">
  <a [routerLink]="" (click)="openSite(1)">{{"START.LINK1"|translate}}</a>
</div>
<div class="h5 py-2 pr-5 font-weight-bold text-md-center">
  <a [routerLink]="" (click)="openSite(2)">{{"START.LINK2"|translate}}</a>
</div> -->



// WEBPACK FOOTER //
// ./src/app/start-page/start-page.component.html